import * as React from 'react';

interface ILargeScreenLayoutProps {
    isVisible: boolean;

    onClose(): void;
}

export const LargeScreenLayout: React.FunctionComponent<ILargeScreenLayoutProps> = props => {
    const { isVisible, children, onClose } = props;

    if (!isVisible) {
        return null;
    }

    return (
        <div className='large-screen-suggest-result'>
            <div onClick={() => onClose()} className='large-screen-suggest-result__background' />
            <div className='large-screen-suggest-result__result-board'>
                {children}
            </div>
        </div>
    );
};
